<template>
  <div class="images-container" ref="ImagesContainer">
    <div class="images" ref="ParallaxImage">
      <div class="image" v-for="image in images">
        <img v-bind:src="absoluteURL(image.url)"/>
      </div>
      <div class="parallax-elements" ref="ParallaxContainer" v-show="runAnimation">
        <div class="parallax-group">
          <div class="parallax-1" ref="Parallax1"></div>
          <div class="parallax-2" ref="Parallax2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {TimelineMax} from 'gsap'
  import ScrollMagic from 'scrollmagic'
  import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'

  export default {
    name: 'Images',
    props: ['images'],
    data() {
      return {
        loading: true,
        values: [],
        controller: new ScrollMagic.Controller(),
        runAnimation: false,
      }
    },
    created() {
      this.loading = false;
      if (this.images.length > 0) {
        this.runAnimation = true;
      }
    },
    mounted() {
      //const {ParallaxContainer} = this.$refs
      this.animations();
    },

    methods: {
      animations() {
        const vw = (coef) => window.innerWidth * (coef / 100)
        const vh = (coef) => window.innerHeight * (coef / 100)

        const {ImagesContainer} = this.$refs
        const {Parallax1} = this.$refs
        const {Parallax2} = this.$refs
        const {ParallaxImage} = this.$refs

        const timelineImage = new TimelineMax({paused: true})
        timelineImage.from(ImagesContainer, 1, {opacity: 0, ease: Power4.easeOut});

        const scene = new ScrollMagic.Scene({
          triggerElement: ImagesContainer,
          triggerHook: 0.85,
          offset: 0
        }).on('enter', function (event) {
          timelineImage.play().timeScale(1);
        }).on('leave', function (event) {
          timelineImage.reverse().timeScale(1.5)
        }).addTo(this.controller);

        const Parallax1Scene = new ScrollMagic.Scene({
          triggerElement: ImagesContainer,
          triggerHook: 1,
          offset: 0,
          duration: "200%"
        })
            .setTween(Parallax1, {y: vh(-80), ease: Linear.easeNone})
            .addTo(this.controller);

        const Parallax2Scene = new ScrollMagic.Scene({
          triggerElement: ImagesContainer,
          triggerHook: 1,
          offset: 0,
          duration: "200%"
        })
            .setTween(Parallax2, {xPercent: -200, ease: Linear.easeNone})
            .addTo(this.controller);

        const ParallaxImageScene = new ScrollMagic.Scene({
          triggerElement: ImagesContainer,
          triggerHook: 1,
          offset: 0,
          duration: "200%"
        })
            .setTween(ParallaxImage, {y: vh(-50), ease: Linear.easeNone})
            .addTo(this.controller);
      },
      absoluteURL(relativeURL) {
        return  process.env.VUE_APP_HOST_URL +  relativeURL;
      }
    },
  }
</script>
